<div class="searchdiv">
    <div class="card screen-wrapper">
        <div class="header headerdiv">
            <h1 class="screen-title">{{ screentitle }}</h1>
        </div>
        <div class="card-body">
            <div class="row">
                <div class="col-md-12">
                    <div class="form-div">
                        <div class="row">
                            <div class="m-portlet">
                                <div class="wr15">
                                    <div style="padding: 2% 4% 2% 2%">
                                        <div>
                                            <div>
                                                <div class="instruct">
                                                    <div class="int1" style="margin-left: 17px">
                                                        <span class="inst" style="font-size: 12px"><strong> Instructions
                                                            </strong></span>
                                                        <br />
                                                        <span class="txt">
                                                            1. Select values: Intermiles No, Airline PNR, Booking Ref No
                                                            , Ticket No, From Refund Date, To Refund Date.
                                                        </span>
                                                        <br />
                                                        <span class="txt">
                                                            2. Please enter a 9-digit IM Number, or an 11-digit Number with `00` prefixed to the 9-digit IM Number.
                                                        </span>
                                                        <br />
                                                        <span></span>
                                                    </div>
                                                </div>
                                                <div class="col-md-3">
                                                    <label>INTERMILES Number </label>
                                                    <input [(ngModel)]="search_details.jp_number" maxlength="11"
                                                        (keypress)="keypresshandler($event)" type="text"
                                                        (input)="isEmpty()" class="form-control m-input"
                                                        placeholder="Enter INTERMILES Number"
                                                        (keyup)="jpNumberValidation();" />
                                                    <span id="JpErr"></span>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Airline PNR</label>
                                                    <input [(ngModel)]="search_details.airline_pnr" type="text"
                                                        class="form-control m-input" placeholder="Enter Airline PNR"
                                                        (input)="isEmpty()" (keyup)="pnrValidation();"
                                                        style="text-transform: uppercase" maxlength="6" />
                                                    <span id="pnrNO"></span>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Booking Reference No</label>
                                                    <input [(ngModel)]="search_details.booking_ref_no" type="text"
                                                        class="form-control m-input" maxlength="18"
                                                        placeholder="Enter Booking Reference No"
                                                        (keyup)="bookingRefValidation();" (input)="isEmpty()"
                                                        style="text-transform: uppercase" />
                                                    <span id="orErr"></span>
                                                </div>
                                                <div class="col-md-3">
                                                    <label class="">Ticket No </label>
                                                    <input [(ngModel)]="search_details.ticket_no" type="text"
                                                        class="form-control m-input" placeholder="Enter Ticket No"
                                                        maxlength="15" (input)="isEmpty()" />
                                                    <span id="orErr"></span>
                                                </div>
                                                <div class="clr"></div>
                                                <div class="divider" style="height:0px !important"></div>
                                                <div class="clr"></div>
                                                <div class="divider" style="height:0px !important"></div>
                                                <div class="col-md-3" style="margin-top: 19px">
                                                    <mat-form-field>
                                                        <input id="did" #input3 matInput
                                                            [(ngModel)]="search_details.refundDate_from"
                                                            [matDatepicker]="pickerFrom1"
                                                            (dateChange)="toggleDisable2();incresedate();isEmpty();"
                                                            autocomplete="off"
                                                            placeholder="From Refund Date" readonly [max]="myDate" />
                                                        <mat-datepicker-toggle matSuffix [for]="pickerFrom1">
                                                        </mat-datepicker-toggle>
                                                        <mat-datepicker #pickerFrom1></mat-datepicker>
                                                    </mat-form-field>

                                                    <button type="button" class="close opa" (click)="reset3() "
                                                        aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                    <br />
                                                </div>
                                                <div class="col-md-3" style="margin-top: 19px">
                                                    <mat-form-field>
                                                        <input [min]="final" #input4 matInput 
                                                            [(ngModel)]="search_details.refundDate_to"
                                                            [matDatepicker]="pickerTO" (dateChange)="isEmpty();"
                                                            autocomplete="off" placeholder="To Refund Date" readonly
                                                            [max]="newDate" />
                                                        <mat-datepicker-toggle matSuffix [for]="pickerTO">
                                                        </mat-datepicker-toggle>
                                                        <mat-datepicker #pickerTO></mat-datepicker>
                                                    </mat-form-field>
                                                    <button type="button" class="close opa" (click)="reset4() "
                                                        aria-label="Close">
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                    <br />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="clr"></div>
                            <div class="wr15">
                                <div class="sdiv">
                                    <div class="btn clear-button button-margin">
                                        <button class="btn btn-primary  commonbutt"
                                            [disabled]="IsEmptyVal == true || IsErr == true "
                                            (click)="searchRefundReport()" type="button">
                                            <em class="fa fa-search "></em>&nbsp;Search
                                        </button>

                                        <button class="btn btn-primary  commonbutt"
                                            [disabled]="IsEmptyVal == true || IsErr == true "
                                            (click)="downloadRefundReport()" type="button">
                                            <em class="fa fa-search "></em>&nbsp;Download
                                        </button>
                                    </div>
                                </div>
                                <div class="sdiv" style="margin-top: 20px;">
                                    <label style="margin-right: 2px;" class=""> Accrual </label>
                                    <input type="radio" value="A" name="type" checked (click)="selectTypeOfJourney('A')">
                                    <label style="margin-left: 8px; margin-right: 2px;" class="">  Redemption</label>
                                    <input type="radio" value="R" name="type" (click)="selectTypeOfJourney('R')">
                                </div>
                                
                            </div>
                            <div class="errwrap">
                                <div class="errdiv1" id="err"></div>
                            </div>
                            <div style="padding: 2% 4% 2% 2%"
                                *ngIf="search_detail_list != '' || search_detail_list != 0" [hidden]="searchlist">
                                <table aria-describedby="fcrBookingDetails" class="table table-striped" *ngIf="!loader"
                                    [mfData]="serachtabledata" [mfRowsOnPage]="6">
                                    <thead>
                                        <tr>
                                            <th scope="col">Booking Reference No</th>
                                            <th scope="col">INTERMILES Number</th>
                                            <th scope="col">Airline PNR</th>
                                            <th scope="col">Ticket No</th>
                                            <th scope="col">Refund Date</th>
                                            <th scope="col">Refund Status</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr class="link" *ngFor="
                                      let item of (search_detail_list
                                        | paginate: { itemsPerPage: 10, currentPage: p ,totalItems:totalItems })
                                    ">
                                            <td>
                                                {{item.ORDER_ID}}
                                            </td>

                                            <td
                                                *ngIf="item.JP_NUMBER == undefind || item.JP_NUMBER == null || item.JP_NUMBER == ''">
                                                NA
                                            </td>
                                            <td
                                                *ngIf="item.JP_NUMBER != undefind && item.JP_NUMBER != null && item.JP_NUMBER != ''">
                                                {{ item.JP_NUMBER }}
                                            </td>
                                            <td
                                                *ngIf="item.AIRLINE_PNR == undefind || item.AIRLINE_PNR == null || item.AIRLINE_PNR == ''">
                                                NA
                                            </td>
                                            <td
                                                *ngIf="item.AIRLINE_PNR != undefind && item.AIRLINE_PNR != null && item.AIRLINE_PNR != ''">
                                                {{ item.AIRLINE_PNR }}
                                            </td>

                                            <td
                                                *ngIf="item.TICKET_NO == undefind || item.TICKET_NO == null || item.TICKET_NO == ''">
                                                NA</td>
                                            <td
                                                *ngIf="item.TICKET_NO != undefind && item.TICKET_NO != null && item.TICKET_NO != '' ">
                                                {{ item.TICKET_NO}}</td>

                                            <td>
                                                {{ item.REFUND_DATE }}
                                            </td>

                                            <td>
                                                {{item.REFUND_STATUS}}
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <td colspan="8">
                                                <pagination-controls (pageChange)="pageCount($event)"
                                                    total-items="totalItems">
                                                </pagination-controls>
                                            </td>
                                        </tr>
                                    </tfoot>
                                </table>
                            </div>
                            <div style="padding: 2% 4% 2% 2%"
                                *ngIf="search_detail_list == '' || search_detail_list == 0">
                                <h1 style="text-align:center" *ngIf="noresult != ''" id="noresulrErr">
                                    {{ noresult }}
                                </h1>
                            </div>
                            <div *ngIf="loader">
                                <div style="margin: 0 auto; text-align: center;">
                                    <img src="../../../assets/img/Loading_Animation.gif" width="4%" height="4%"
                                        alt="Loader" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>